import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useSidebarContext } from './SidebarContext';
const SidebarLogo = ({ children, className, href, img, imgAlt = '', ...rest }) => {
    const { collapsed } = useSidebarContext();
    return (_jsxs("a", { className: classNames('mb-5 flex items-center pl-2.5', className), href: href, ...rest, children: [_jsx("img", { alt: imgAlt, className: "mr-3 h-6 sm:h-7", src: img }), _jsx("span", { className: classNames(collapsed ? 'sr-only' : 'self-center whitespace-nowrap text-xl font-semibold dark:text-white'), "data-testid": "sidebar-logo", children: children })] }));
};
SidebarLogo.displayName = 'Sidebar.Logo';
export default SidebarLogo;
